<template>
  <div class="messages__stage" ref="messages-stage">
    <div class="messages">
      <TicketsChatMessagesItem v-for="(message,i) in messages" :key="i"
                               :message="message"
                               :userMessage="isUserMessage(message.user_id)"/>
    </div>
  </div>
</template>

<script>
import TicketsChatMessagesItem from "@/components/cabinet/Tickets/TicketsChat/TicketsChatMessagesItem";
import {mapState} from "vuex";

export default {
  name: "TicketsChatMessages",
  components: {TicketsChatMessagesItem},
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState('cabinet/user', ['user_info'])
  },
  methods: {
    isUserMessage(id) {
      return this.user_info.data.id === id;
    },
    scrollDown() {
      this.$refs['messages-stage'].scrollTop = this.$refs['messages-stage'].scrollHeight
    }
  },
  mounted() {
    this.scrollDown();
  }
}
</script>

<style lang="scss" scoped>
.messages {
  @apply flex flex-col justify-end mb-12 -mt-13 pt-13;

  &__stage {
    height: calc(100vh - 420px);
    min-height: 250px;
    overflow-y: scroll;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

</style>